module.exports = __webpack_public_path__ + "static/img/cat2_tr.430d1538.png";